<template>
  <textarea
    :rows="rowCount" 
    class="basic-textarea"
    :value="value"
    :placeholder="placeholder"
    @input="$emit('input', $event.target.value)"
    @focus="$emit('focus')"
    ></textarea>
</template>

<script>
export default {
  props: ["value", "placeholder", "rowCount"],
  mounted() {}
}
</script>

<style lang="scss">
.basic-textarea {
  width: 100%;
  background-color: #303030;
  border: 1px solid #555555;
  padding: 8px 10px;
  color: rgba(255,255,255,0.85);
  resize: vertical;
  height: auto;
  font-size: 13px;
  border-radius: 2px;

  &:focus {
    border-color: #FBB442;
  }
}
</style>